import { useTranslation } from "@sagot/i18n";
import { Skeleton } from "@sagot/ui";

/** Skeleton with the page's own shape: title, one line of summary and the card. Announced politely as loading (BUG-SD-003). */
export function ServiceAreaSkeleton() {
  const { t } = useTranslation();
  return (
    <div className="mx-auto max-w-5xl space-y-4" role="status" data-testid="service-area-skeleton">
      <span className="sr-only">{t("service.loading")}</span>
      <Skeleton className="h-8 w-[220px]" />
      <Skeleton className="h-4 w-[420px] max-w-full" />
      <Skeleton className="h-40" />
    </div>
  );
}
